import React, { createContext, useContext } from "react";

const TeamAdminFiltersContext = createContext({ brand: "all", ort: "all" });

export const TeamAdminBrandProvider = ({ brand, ort = "all", children }) => (
  <TeamAdminFiltersContext.Provider value={{ brand, ort }}>
    {children}
  </TeamAdminFiltersContext.Provider>
);

export const useTeamAdminBrand = () => useContext(TeamAdminFiltersContext).brand;

export const useTeamAdminOrt = () => useContext(TeamAdminFiltersContext).ort;
